// @ts-nocheck
import { ToolkitProperty, expected } from '@aloft/toolkit-shared';

import { PairedSaleIDs } from '../../types.js';
import { PairedSalesTableRow } from './types.js';

export function makePairedSalesTableRows({
  pairs,
  properties,
}: {
  pairs: PairedSaleIDs[];
  properties: Record<string, ToolkitProperty>;
}): PairedSalesTableRow[] {
  return pairs.map((pair) => ({
    p1: expected(properties[pair.p1]),
    p2: expected(properties[pair.p2]),
  }));
}
